import React, { useState, useEffect } from "react";
import "new_components/AboutUs/AboutUs.scss";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
import axios from "axios";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";
import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";

const PrivacyPolicy = () => {
  return (
    <>
      <ScrollToTopDefault />
      <Header />
      <ProgressCircle />
      <Body />
      <Footer />
    </>
  );
};

const Body = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const Preload = () => {
    return (
      <div className="preload preload-container">
        <div className="preload-logo">
          <div className="spinner" />
          <span className="icon icon-villa-fill" />
        </div>
      </div>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cachedData = sessionStorage.getItem("privacyPolicy");

        if (cachedData) {
          setData(JSON.parse(cachedData));
          setLoading(false);
          return;
        }

        const response = await axios.get(apiUrls.privacyPolicy);
        if (response.data?.content) {
          setData(response.data);

          sessionStorage.setItem(
            "privacyPolicy",
            JSON.stringify(response.data)
          );
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div>
        <Preload />
      </div>
    );
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <>
      <div
        className="p-4"
        dangerouslySetInnerHTML={{
          __html: data.content || "Description not available",
        }}
      ></div>
    </>
  );
};

export default PrivacyPolicy;
